import { render } from "./WhatsappNumbers.vue?vue&type=template&id=7d01e10c"
import script from "./WhatsappNumbers.vue?vue&type=script&lang=js"
export * from "./WhatsappNumbers.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__